import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { PostApi, GetApi } from '../../../js_assets/Network';
import axios from 'axios'
import { api_url } from '../../../js_assets/ConfigApp';


import CircularProgress from '@material-ui/core/CircularProgress';

import AppAdminContainer from '../AppAdminContainer'
import List from '@material-ui/core/List';
import SearchIcon from '@material-ui/icons/Search';
import Dialog from '@material-ui/core/Dialog';

import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Slide from '@material-ui/core/Slide';

import CloseIcon from '@material-ui/icons/Close';
import Event from '@material-ui/icons/Event';
import LocalShipping from '@material-ui/icons/LocalShipping';

import ReactToPrint from 'react-to-print';
import Hammer from 'react-hammerjs';
function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    divider: {
        width: '100%',
    },
    ButtonGuide: {
        backgroundColor: '#74cbc4',
        color: 'white',
        '&:hover': {
            background: '#74cbc4'
        },
        margin: theme.spacing.unit * 0.5,
        padding: '4px 5px',
        borderRadius: '5px',
        fontSize: 15,
        boxShadow: ' 0 4px 8px 0 rgba(0,0,0,0.2);',
        fontFamily: [
            'DIN-NEXT™-ARABIC-BOLD',
        ].join(','),
    },
    iocns: {
        fontSize: 18
    },
    canceliocn: {
        color: 'black',
        float: 'left'
    },
    p_followUp_Schedule_Description: {
        maxWidth: 270,
        lineHeight: '2.7em'
    },
    ButtonSubscription: {
        backgroundColor: '#74cbc4',
        color: 'white',
        '&:hover': {
            background: '#74cbc4'
        },
        fontSize: 15,
        boxShadow: ' 0 4px 8px 0 rgba(0,0,0,0.2);',
        fontFamily: [
            'DIN-NEXT™-ARABIC-BOLD',
        ].join(','),
    },
    btn_login: {
        color: 'white',
        padding: '10px 1px',
        border: 'none',
        cursor: 'pointer',
        width: '100%',
        opacity: '0.9',
        borderRadius: '3px',
        fontFamily: [
            'DIN-NEXT™-ARABIC-BOLD',
        ].join(','),
    }, ButtonSearch: {
        backgroundColor: '#007bff',
        color: 'white',
        '&:hover': {
            background: '#007bff'
        }
    },
    centerNofound: {
        position: 'fixed',
        top: '41%',
        left: '32%',
        width: '150px',
    }
    , ItemImage: {

        borderRadius: " 10px",
        width: '120px',
        height: '120px'
    }
    , font16px: {

        fontSize: 16
        ,
        fontFamily: [
            'DIN-NEXT™-ARABIC-BOLD',
        ].join(','),
    }
});

class AdminListOrders extends Component {

    constructor(props) {
        super(props);

        this.state = {
            Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
            Order_data: [],
            Order_data_by_Status: [],
            payment_Type: [],
            Order_Status_Type: [],
            list_Citys: [],
            loading_state_iocn: false,
            error_message_state: false,
            Update_Order_Status_Button_state: false,
            error_message_text: '',
            success_message_state: false,
            success_message_text: '',
            list_item_in_order: [],
            form_List_Item: false,
            form_Update_Order_Status: false,
            Updated_Order_Status: "0",
            selected_order_Number: "0",
            selected_user_TokenId: "0",
            selected_mobile_Type: "",
            selected_order_summary: null,
            form_StroreInvoice: false
        };
    }



    get_order_by_order_number = (Order_Number) => {

        const { Admin_Info } = this.state;
        this.setState({ loading_state_iocn: true, Order_data: [] })

        //console.log(Admin_Info)

        this.setState({ loading_state_iocn: true })
        //console.log("Order_Number get_order_by_order_number");
        //console.log(Order_Number);




        let Get_Order_By_Order_Number = GetApi(`/api/Order/Get_Order_By_Order_Number/${Admin_Info.admin_Id}/${Order_Number}`, Admin_Info.jwT_Token_Admin);

        Get_Order_By_Order_Number.then(rep => {


            //console.log(rep[0])
        })






    }



    get_init_data = () => {


    }







    get_payment_Type = (id) => {

        const { payment_Type } = this.state

        let list_pay = [];

        let result = "";

        list_pay = payment_Type;

        list_pay.map(item => {

            if (item.payment_Type_ID == id) {


                result = item.payment_Type_Name;
            }


        })



        return result;
    }

    get_city_name = (id) => {

        const { list_Citys } = this.state


        let list_ci = [];

        let result = "";

        list_ci = list_Citys;

        list_ci.map(item => {

            if (item.city_Id == id) {


                result = item.city_Name;
            }


        })



        return result;
    }
    get_Order_Status_Type = (id) => {

        const { Order_Status_Type } = this.state

        let list_Order_Status_Type = [];

        let result = "";

        list_Order_Status_Type = Order_Status_Type;

        list_Order_Status_Type.map(item => {

            if (item.order_Status_Type_ID == id) {


                result = item.order_Status_Type_Name;
            }


        })



        return result;
    }




    get_order_date(order_Date) {

        var Order_date = new Date(Date.parse(order_Date))
        var datetime_order = Order_date.toISOString().split('T')[0]



        return datetime_order;
    }



    Apply_confirm_cancel_order = (selected_order_summary) => {

        const { Admin_Info } = this.state;

        this.setState({ loading_state_iocn: true })

        let Add_Order_To_Cancel_Order = PostApi(`/api/Order/Add_Order_To_Cancel_Order/${Admin_Info.admin_Id}`, selected_order_summary, Admin_Info.jwT_Token_Admin);

        Add_Order_To_Cancel_Order.then(() => {

            GetApi(`/api/Order/Remove_Order_V2/${Admin_Info.admin_Id}/${selected_order_summary.order_Number}`, Admin_Info.jwT_Token_Admin).then(() => {

                this.setState({ success_message_state: true, success_message_text: 'تم الغاء الطلب' });
            })

        })


    }



    redirectToUrl = (Component) => {

        window.location.href = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + Component
    }


    handleClose_error_message = () => {
        this.setState({ error_message_state: false, error_message_text: '' });
    };

    handleClose_success_message = () => {
        this.setState({ success_message_state: false, success_message_text: '' });
    };


    render() {
        const { classes } = this.props;
        const { Order_data, loading_state_iocn, Order_Status_Type } = this.state;
        let optionItems = Order_Status_Type.map((type) => <option value={type.order_Status_Type_ID} key={type.order_Status_Type_ID}>{type.order_Status_Type_Name}</option>);



        return (
            <AppAdminContainer Title={"الطلبات"} >

                <div>

                    <div>
                        <br />
                        <Grid container spacing={24} className={classes.root}   >


                            <Grid item xs   >
                                <div >

                                    <input placeholder=" رقم الطلب" name="ref_Order_number" ref="ref_Order_number" />
                                </div>
                            </Grid>


                            <Grid item xs>
                                <Hammer onTap={() => this.get_order_by_order_number(this.refs.ref_Order_number.value)}>
                                    <div>
                                        <button size="small" variant="contained" className={classes.ButtonSearch}    >
                                            <SearchIcon />
                                        </button>
                                    </div>
                                </Hammer>

                            </Grid>






                        </Grid>
                    </div>


                    <Divider className={classes.divider} />


                    <div>

                        <div>


                            {loading_state_iocn ? <div className="centerloadingicon" ><CircularProgress /></div> : Order_data.length == 0 ? <img className={classes.centerNofound} src="/assets/imags/app_icon/empty-cart.svg" width={500}></img> :

                                Order_data.map((off) => {

                                    var Order_date = new Date(Date.parse(off.order_Date))
                                    var datetime_order = Order_date.toISOString().split('T')[0]

                                    return (



                                        <div>
                                            <div className="w3-cell-row">
                                                <div className="w3-cell">
                                                    <img className={classes.ItemImage} src={`${api_url}/Content/Store_Image/${off.store_Image}`} ></img>
                                                </div>
                                                <div className="w3-cell w3-container" >

                                                    <span>  المتجر  </span> : <span>{off.store_Name} </span><br />
                                                    <span>  اسم العميل </span> : <span>{off.userName} </span><br />
                                                    <span>  رقم الجوال </span> : <span>{off.user_Phone} </span><br />
                                                    {/* <span>  المنطقة </span> : <span>{this.get_city_name(off.city_Id)} </span><br />
                                                    <span>  الحي </span> : <span>{off.user_District} </span><br /> */}
                                                    <span>  رقم الطلب </span> : <span>{off.order_Number} </span><br />
                                                    {/* <span> حالة الشحن </span> : <span>{this.get_Order_Status_Type(off.order_Status_Type_ID)} </span><br /> */}
                                                    <span> اجمالي المبلغ </span> : <span>{off.order_Total_Amount} ريال </span><br />
                                                    {parseFloat(off.order_Total_Amount_Before_Discount) != 0 ? <div> <span>  الاجمالي قبل الخصم </span> : <span>{off.order_Total_Amount_Before_Discount} ريال </span><br /> </div> : null}
                                                    <i ><Event className={classes.iocns} /> </i>  <span >  {datetime_order}</span><br />
                                                    <i ><LocalShipping className={classes.iocns} /> </i>  <span >  {parseFloat(off.delivery_Price) == 0 ? "مجاني" : off.delivery_Price + " " + "ريال "}  </span><br />
                                                    {/* <span>  الدفع </span> : <span>{this.get_payment_Type(off.payment_Type_ID)} </span><br /> */}


                                                    <button size="small" variant="contained" className={classes.ButtonGuide} onClick={() => this.Apply_confirm_cancel_order(off)} >
                                                        <span > الغاء الطلب</span>
                                                    </button>



                                                </div>

                                                <br />





                                            </div>


                                            <Divider className={classes.divider} />
                                        </div>


                                    )



                                })

                            }



                        </div>









                    </div>










                    <Dialog
                        open={this.state.success_message_state}
                        onClose={this.handleClose_success_message}
                        TransitionComponent={Transition}
                        keepMounted

                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogTitle id="alert-dialog-slide-title">
                            <div className="alertIcon">✔️ <label>{this.state.success_message_text} </label> </div>
                        </DialogTitle>


                    </Dialog>


                </div>
            </AppAdminContainer >
        )


    }


}
AdminListOrders.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminListOrders);